import { abrePDF } from "../../../utils/pdf";
import React, { useState, useEffect, useContext, useMemo } from "react";
import { fDMA } from "../../../utils/fecha";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
  Badge
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import qrcode from "qrcode-js";
import moment from 'moment';

// Un pago lleva comisión, viáticos o las dos cosas (importe = comisión +
// ajuste + viáticos). Los "viáticos extra" se pagan solos.
const tipoComision = (a) => {
  const via = Number(a.viaticos) || 0;
  const com = (Number(a.importe) || 0) - via;
  if (via > 0 && com > 0.005) return "Comisión y viático";
  if (via > 0) return "Viático";
  return "Comisión";
};

function ListadoComisiones() {
  const { user } = useContext(AuthContext);
  const URL_COMISIONES = process.env.REACT_APP_URL_COMISIONES;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_MOVIMIENTOS_BANCOS = process.env.REACT_APP_URL_MOVIMIENTOS_BANCOS;
  const URL_SURTIDOS = process.env.REACT_APP_URL_SURTIDOS;


  let hoy = new Date()
  let inicio = new Date()
  inicio.setDate(inicio.getDate()-30);
 
  let endDate   = moment(hoy).format("YYYY-MM-DD"); 
  let startDate   = moment(inicio).format("YYYY-MM-DD");

  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  // Filtro por tipo: "" todos, "Comisión", "Viático", "Comisión y viático",
  // "conViatico" (todo lo que lleve viático)
  const [selectedTipo, setSelectedTipo] = useState("");
  const pasaTipo = (a) =>
    !selectedTipo || (selectedTipo === "conViatico" ? Number(a.viaticos) > 0 : a.tipo === selectedTipo);
  // Filtro activas / canceladas. Default: solo activas.
  const [activo, setActivo] = useState("Si");
 
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [idEdit, setIdEdit] = useState("");
  const [vendedor, setVendedor] = useState("");
  const [importe, setImporte] = useState("");
  const [porcentaje, setPorcentaje] = useState(0);
  const [total, setTotal] = useState("");
  const [importeNuevo, setImporteNuevo] = useState("");

  const [modalPagar, setModalPagar] = useState(false);
  const togglePagar = () => setModalPagar(!modalPagar);
  const [selectedBanco, setSelectedBanco] = useState("");
  const [bancos, setBancos] = useState([]);
  const [moneda, setMoneda] = useState("");
  const [idPagar, setIdPagar] = useState("");
  const [idVendedorPagar, setIdVendedorPagar] = useState("");
  const [importePagar, setImportePagar] = useState(0);

  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  // Modal Pagar Viatico Extra
  const [modalViaticoExtra, setModalViaticoExtra] = useState(false);
  const toggleViaticoExtra = () => setModalViaticoExtra(!modalViaticoExtra);
  const [vxColaborador, setVxColaborador] = useState("");
  const [vxMonto, setVxMonto] = useState(0);
  const [vxConcepto, setVxConcepto] = useState("Viatico Extra");
  const [vxFecha, setVxFecha] = useState(moment(new Date()).format("YYYY-MM-DD"));

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(()=>{

    axios
      .get(`${URL_COMISIONES}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allDevoluciones = response.data;
        // Array para pagination
        let arrayTabla = allDevoluciones
          .sort((a, b) => (a.idDevolucion > b.idDevolucion ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              is_active:a.is_active,
              fecha: a.fecha,
              vendedor: a.colaboradores[0].nombre + " " + a.colaboradores[0].apellido,
              idVendedor: a.colaboradores[0]._id,
              bancoEmp: a.colaboradores[0].banco || "",
              clabeEmp: a.colaboradores[0].clabe || "",
              titularEmp: a.colaboradores[0].titularCuenta || "",
              importe: a.importe,
              porcentaje: a.porcentaje,
              numero: a.idComision,
              pagada: a.pagada,
              total: a.total,
              // Datos para el PDF con el detalle de lo que se paga
              viaticos: a.viaticos || 0,
              semanas: a.semanas || 0,
              periodoViaticos: a.periodoViaticos || "",
              concepto: a.concepto || "",
              viaticosAjuste: Number(a.viaticosAjuste) || 0,
              conceptoAjuste: a.conceptoAjuste || "",
              comisionAjuste: Number(a.comisionAjuste) || 0,
              conceptoComisionAjuste: a.conceptoComisionAjuste || "",
              tipo: tipoComision(a),
            }
          })
          .filter(function (el) {
            return el != null;
          });

        let data = Object.values(arrayTabla);
        setComments(data);
        //
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_BANCOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allBancos = response.data;
        setBancos(allBancos);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColaboradores = response.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });

  }, [selectedFechaInicio, selectedFechaFin]);


  function abrirViaticoExtra() {
    setVxColaborador("");
    setVxMonto(0);
    setVxConcepto("Viatico Extra");
    setVxFecha(moment(new Date()).format("YYYY-MM-DD"));
    toggleViaticoExtra();
  }

  function saveViaticoExtra() {
    if (!vxColaborador || Number(vxMonto) <= 0 || !vxConcepto) {
      Swal.fire({
        icon: "error",
        title: "Datos incompletos",
        text: "Selecciona colaborador, monto y concepto",
      });
      return;
    }
    axios
      .post(
        `${URL_COMISIONES}`,
        {
          fecha: vxFecha,
          importe: Number(vxMonto),
          colaboradores: vxColaborador,
          porcentaje: 0,
          total: 0,
          viaticos: Number(vxMonto),
          semanas: 0,
          tipoViaticos: "Extra",
          periodoViaticos: "",
          concepto: vxConcepto,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Pagar Viatico Extra",
            detalle: `Colaborador ${vxColaborador} / Monto ${vxMonto} / Concepto ${vxConcepto}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        Swal.fire("Listo", "Viatico extra registrado", "success");
        setTimeout(() => window.location.reload(), 1000);
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo registrar el viatico",
          footer: err?.response?.data?.message || err.message,
        });
      });
  }

  // W14: Reporte comisiones a pagar con datos bancarios
  function PDFTablaBancos() {
    const filtered = comments.filter((a) =>
      (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
      (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
      (selectedColaborador == 0 || selectedColaborador == a.idVendedor) &&
      a.pagada !== "Si"
    );
    // Agrupar por vendedor
    const agrup = filtered.reduce((acc, a) => {
      const key = a.idVendedor || a.vendedor;
      if (!acc[key]) {
        acc[key] = {
          vendedor: a.vendedor,
          banco: a.bancoEmp || "",
          clabe: a.clabeEmp || "",
          titular: a.titularEmp || "",
          importe: 0,
          notas: 0,
        };
      }
      acc[key].importe += Number(a.importe || 0);
      acc[key].notas += 1;
      return acc;
    }, {});
    const body = Object.values(agrup).map((v) => [
      v.vendedor,
      v.banco,
      v.clabe,
      v.titular,
      v.notas,
      new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(v.importe),
    ]);
    const doc = new jsPDF();
    doc.setFontSize(14);
    doc.text("Comisiones por Pagar", 14, 18);
    doc.setFontSize(10);
    doc.text(`Periodo: ${selectedFechaInicio} - ${selectedFechaFin}`, 14, 26);
    doc.autoTable({
      head: [["Vendedor", "Banco", "CLABE", "Titular de la cuenta", "# Notas", "Importe"]],
      body,
      startY: 32,
      theme: "grid",
      styles: { fontSize: 9 },
      headStyles: { fillColor: [176, 35, 7] },
    });
    abrePDF(doc, "ComisionesPorPagar.pdf");
  }

  // PDF con el DETALLE de una comisión: las ventas que la generaron,
  // la comisión calculada y los viáticos que se están pagando.
  // soloDoc: regresa el PDF en vez de abrirlo (para mandarlo por correo)
  async function PDFOC(a, { soloDoc = false } = {}) {
    const money = (n) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2,
      }).format(Number(n) || 0);

    // El % de cada nota, con la misma precedencia que ComisionesCreate:
    // pactado en la cotización > especial del cliente (ficha del vendedor) > general
    const vend = colaboradores.find((c) => String(c._id) === String(a.idVendedor)) || {};
    const pctGeneral = Number(a.porcentaje) || 0;
    const pctCliente = (idCliente) => {
      const hit = (vend.comisionesPorCliente || []).find(
        (c) => String(c?.clientes?._id || c?.clientes || "") === String(idCliente || "")
      );
      return hit ? Number(hit.porcentaje || 0) : 0;
    };

    let ventas = [];
    try {
      const resp = await axios.get(`${URL_SURTIDOS}Comision/${a._id}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      });
      ventas = (resp.data || [])
        .map((s) => {
          const cliente0 = s.clientes?.[0] || s.pedidos?.[0]?.clientes?.[0] || {};
          const pactado = Number(s.pedidos?.[0]?.comisionPorcentaje || 0);
          const especial = pctCliente(cliente0._id);
          const pct = pactado > 0 ? pactado : especial > 0 ? especial : pctGeneral;
          // Misma base con la que se pagó en ComisionesCreate
          const conIva = Number(s.total_general) || 0;
          const base = vend.momentoComision === "DespuesIVA" ? conIva : conIva / 1.16;
          return {
            numero: s.idSurtido,
            fecha: s.fecha,
            cliente: cliente0.nombre_comercial || "",
            base,
            pct,
            origenPct: pactado > 0 ? "cotización" : especial > 0 ? "cliente" : "",
            comision: (base * pct) / 100,
          };
        })
        .sort((x, y) => String(x.fecha).localeCompare(String(y.fecha)));
    } catch (err) {
      console.log("[PDFOC comision]", err);
    }

    const baseVentas = ventas.reduce((t, v) => t + v.base, 0);
    const conPctEspecial = ventas.filter((v) => v.origenPct).length;
    // Con ventas: suma nota por nota (cada una con su %); sin ventas, el general
    const comision = ventas.length
      ? ventas.reduce((t, v) => t + v.comision, 0)
      : Number(a.total) * pctGeneral / 100;
    const viaticos = Number(a.viaticos) || 0;
    const totalPagar = Number(a.importe) || comision + (Number(a.comisionAjuste) || 0) + viaticos;

    const doc = new jsPDF();
    const img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 12, 8, 33, 18);

    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text(`RECIBO DE COMISIONES # ${a.numero}`, 105, 16, { align: "center" });
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text(`Fecha: ${a.fecha}`, 105, 23, { align: "center" });

    doc.text(`Vendedor: ${a.vendedor}`, 12, 34);
    if (a.bancoEmp) doc.text(`Banco: ${a.bancoEmp}`, 12, 39);
    if (a.clabeEmp) doc.text(`CLABE: ${a.clabeEmp}`, 12, 44);
    if (a.titularEmp) doc.text(`Titular de la cuenta: ${a.titularEmp}`, 12, 49);
    if (a.pagada === "Si") {
      doc.setFont("helvetica", "bold");
      doc.text("PAGADA", 198, 34, { align: "right" });
      doc.setFont("helvetica", "normal");
    }

    // Detalle de ventas que generaron la comisión. Las notas con % distinto
    // al general (cliente especial o pactado en la cotización) van marcadas.
    doc.autoTable({
      head: [["Nota", "Fecha", "Cliente", "Base", "%", "Comisión"]],
      body: ventas.length
        ? ventas.map((v) => [
            v.numero,
            v.fecha,
            v.cliente,
            money(v.base),
            v.origenPct ? `${v.pct}% (${v.origenPct})` : `${v.pct}%`,
            money(v.comision),
          ])
        : [["", "", "Sin ventas ligadas a esta comisión", "", "", ""]],
      foot: ventas.length
        ? [["", "", "Suma de ventas", money(baseVentas), "", money(comision)]]
        : undefined,
      headStyles: { fillColor: ["#B02307"], lineWidth: 0 },
      footStyles: { fillColor: ["#B02307"] },
      columnStyles: { 3: { halign: "right" }, 4: { halign: "center" }, 5: { halign: "right" } },
      theme: "grid",
      styles: { fontSize: 9 },
      didParseCell: (d) => {
        if (d.section === "body" && ventas[d.row.index]?.origenPct) {
          d.cell.styles.fillColor = [255, 243, 205];
          if (d.column.index === 4) d.cell.styles.fontStyle = "bold";
        }
      },
      // Con titular hay una línea más arriba: se baja la tabla para no encimarla
      startY: a.titularEmp ? 54 : 50,
    });
    if (conPctEspecial) {
      doc.setFontSize(8);
      doc.text(
        `Marcadas en amarillo: ${conPctEspecial} nota(s) con porcentaje distinto al general (${pctGeneral}%).`,
        12,
        doc.lastAutoTable.finalY + 4
      );
      doc.setFontSize(10);
    }

    // Resumen de lo que se paga
    const resumen = [
      ["Base de ventas", money(a.total)],
      [
        conPctEspecial
          ? `Comisión (${pctGeneral}% general + % especiales marcados)`
          : `Comisión (${pctGeneral}%)`,
        money(comision),
      ],
    ];
    const ajusteCom = Number(a.comisionAjuste) || 0;
    if (ajusteCom !== 0) {
      resumen.push([
        `${ajusteCom > 0 ? "Bono / ajuste a comisión" : "Descuento a comisión"}${
          a.conceptoComisionAjuste ? ` · ${a.conceptoComisionAjuste}` : ""
        }`,
        money(ajusteCom),
      ]);
    }
    // `viaticos` ya trae el ajuste sumado; en el recibo se muestran por separado
    const ajuste = Number(a.viaticosAjuste) || 0;
    const viaticosPeriodo = viaticos - ajuste;
    if (viaticosPeriodo > 0) {
      const detalleV = [
        a.semanas ? `${a.semanas} periodo(s)` : "",
        a.periodoViaticos || "",
      ].filter(Boolean).join(" · ");
      resumen.push([`Viáticos${detalleV ? ` (${detalleV})` : ""}`, money(viaticosPeriodo)]);
    }
    if (ajuste !== 0) {
      resumen.push([
        `${ajuste > 0 ? "Viáticos adicionales" : "Descuento a viáticos"}${a.conceptoAjuste ? ` · ${a.conceptoAjuste}` : ""}`,
        money(ajuste),
      ]);
    }
    resumen.push(["TOTAL A PAGAR", money(totalPagar)]);

    doc.autoTable({
      body: resumen,
      startY: doc.lastAutoTable.finalY + (conPctEspecial ? 9 : 6),
      theme: "grid",
      styles: { fontSize: 10 },
      columnStyles: {
        0: { cellWidth: 120, fontStyle: "bold" },
        1: { halign: "right" },
      },
      margin: { left: 12 },
      didParseCell: (d) => {
        if (d.row.index === resumen.length - 1) {
          d.cell.styles.fillColor = ["#B02307"];
          d.cell.styles.textColor = ["#ffffff"];
          d.cell.styles.fontStyle = "bold";
        }
      },
    });

    const yFirma = doc.lastAutoTable.finalY + 30;
    doc.setFontSize(9);
    doc.line(20, yFirma, 90, yFirma);
    doc.text("Recibí de conformidad", 35, yFirma + 5);
    doc.text(a.vendedor || "", 35, yFirma + 10);

    if (soloDoc) return doc;
    abrePDF(doc, `Comision-${a.numero}.pdf`);
  }

  // Al registrar el pago se le manda al vendedor su recibo en PDF.
  // Regresa un texto para el aviso; si falla, el pago ya quedó registrado.
  async function enviaReciboVendedor(idComision, idVendedor) {
    const row = comments.find((c) => c._id === idComision);
    const vend = colaboradores.find((c) => String(c._id) === String(idVendedor));
    const email = String(vend?.email || "").trim();
    if (!row) return "";
    if (!email) return "El vendedor no tiene correo en su ficha, no se le mandó el recibo.";
    try {
      const doc = await PDFOC({ ...row, pagada: "Si" }, { soloDoc: true });
      const money = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(Number(row.importe) || 0);
      await axios.post(
        URL_SEND_MAIL_ATT,
        {
          subject: `Pago de comisión #${row.numero}`,
          email,
          fileName: `Comision-${row.numero}.pdf`,
          att: encode(doc.output("arraybuffer")),
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola ${row.vendedor},</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Se registró el pago de tu comisión #${row.numero} por ${money}. Adjunto encontrarás el recibo con el detalle.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         </table>`,
        },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      return `Se le mandó el recibo a ${email}.`;
    } catch (err) {
      console.log("[recibo comision]", err);
      return "No se pudo mandar el recibo por correo; descárgalo desde el listado.";
    }
  }

  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedColaborador == 0 || selectedColaborador == a.idVendedor) &&
        pasaTipo(a)
      ) {
        return [
          a.numero,
          a.fecha,
          a.vendedor,
          a.tipo,
          a.porcentaje,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.viaticos || 0),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.importe),
        ];
      }
    });

    const dataPDF = Object.values(data);

    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });


    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 35, 18);
    doc.text(`Listado Comisiones`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Fecha",
          "Vendedor",
          "Tipo",
          "Porcentaje",
          "Viáticos",
          "Total",
        ],
      ],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#B02307"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#B02307"],
          },
          theme:"grid",
      startY: 45,
    });
    abrePDF(doc, `Comisiones.pdf`);
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedColaborador == 0 || selectedColaborador == a.idVendedor) &&
        pasaTipo(a)
      ) {
        return {
          Numero: a.numero,
          Fecha: a.fecha,
          Vendedor: a.vendedor,
          Tipo: a.tipo,
          Porcentaje: a.porcentaje,
          Viaticos: Number(a.viaticos || 0),
          Importe: a.importe,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoComisiones";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoComisiones",
        sheetFilter: [
          "Numero",
          "Fecha",
          "Vendedor",
          "Tipo",
          "Porcentaje",
          "Viaticos",
          "Importe",
        ],
        sheetHeader: [
          "Numero",
          "Fecha",
          "Vendedor",
          "Tipo",
          "Porcentaje",
          "Viáticos",
          "Total",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedColaborador == 0 || selectedColaborador == a.idVendedor) &&
        pasaTipo(a)
      ) {
        return [
          a.numero,
          a.fecha,
          a.vendedor,
          a.tipo,
          a.porcentaje,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.viaticos || 0),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.importe),
        ];
      }
    });

    const dataPDF = Object.values(data);

    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });


    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 35, 18);
    doc.text(`Listado Comisiones`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Fecha",
          "Vendedor",
          "Tipo",
          "Porcentaje",
          "Viáticos",
          "Total",
        ],
      ],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#B02307"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#B02307"],
          },
          theme:"grid",
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Comisiones",
          email: mailTo,
          fileName: "ListadoComisiones.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Comisiones.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

 
  // async function PDFOC(
  //   fecha,
  //   clientes,
  //   numero,
  //   idPDFOC,
  //   impuestos,
  //   area,
  //   subTotal,
  //   iva,
  //   total_general,
  //   total_cantidad
  // ) {
  //   await axios
  //     .get(`${URL_ARTICULOS_DEVOLUCIONES}/devolucion/${idPDFOC}`, {
  //       headers: {
  //         Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //       },
  //     })
  //     .then((response) => {
  //       let allArticulosDevolucion = response.data;
  //       let arrayTabla = allArticulosDevolucion
  //         .map((a) => {
  //           return {
  //             id: a._id,
  //             articulos: a.articulos[0].codigo + " " + a.articulos[0].nombre,
  //             cantidad: a.cantidad,
  //             defectos: a.defectos,
  //             totalPiezas: a.totalPiezas,
  //             precio: a.precio,
  //             total: a.total,
  //           };
  //         })
  //         .filter(function (el) {
  //           return el != null;
  //         });

  //       let dataFinal = Object.values(arrayTabla);

  //       const data = dataFinal.map((a) => {
  //         return [
  //           a.articulos,
  //           new Intl.NumberFormat("en-US").format(a.cantidad),
  //           new Intl.NumberFormat("en-US").format(a.defectos),
  //           new Intl.NumberFormat("en-US").format(a.totalPiezas),
  //           new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.precio),
  //           new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total),
  //         ];
  //       });
  //       const dataPDF = Object.values(data);
  //       const dataPDFLimpia = dataPDF.filter(function (el) {
  //         return el != null;
  //       });

  //       const doc = new jsPDF("landscape", "mm", "a4", true);
  //       var base64 = qrcode.toDataURL(idPDFOC);
  //       var img3 = new Image();
  //       img3.src = base64;
  //       doc.addImage(img3, "png", 230, 17, 25, 25);
  //       var img = new Image();
  //       var img2 = new Image();
  //       img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
  //       doc.addImage(img2, "png", 255, 23, 23, 10);
  //       doc.text(`Devolucion # ${numero}`, 20, 20);
  //       doc.setFontSize(12);
  //       doc.text(`Almacen: ${area}`, 20, 25);
  //       doc.text(`Fecha: ${fecha}`, 20, 30);
  //       doc.text(`Cliente: ${clientes}`, 20, 35);
  //       doc.text(
  //         `Total: ${new Intl.NumberFormat("en-US").format(
  //           total_cantidad
  //         )} piezas`,
  //         20,
  //         40
  //       );

  //       doc.autoTable({
  //         head: [["Articulo", "Cantidad", "Defecto", "Total Piezas", "Precio", "Total"]],
  //         body: dataPDFLimpia,
  //         startY: 42,
  //         foot: [
  //           [
  //             "",
  //             "",
  //             "",
  //             "",
  //             "Sub Total",
  //             new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(subTotal),
  //           ],
  //           [
  //             "",
  //             "",
  //             "",
  //             "",
  //             `IVA ${impuestos}%`,
  //             new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(iva),
  //           ],
  //           [
  //             "",
  //             "",
  //             "",
  //             "",
  //             "Total",
  //             new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(total_general),
  //           ],
  //         ],
  //         showFoot: "lastPage",
  //       });

  //       abrePDF(doc, `Devolucion-${numero}.pdf`);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }



  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Vendedor", field: "vendedor", sortable: true },
    { name: "Tipo", field: "tipo", sortable: true },
    { name: "Total", field: "total", sortable: true },
    { name: "Porcentaje", field: "porcentaje", sortable: true },
    { name: "Importe", field: "importe", sortable: true },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.vendedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.importe.toString().includes(search) 
      );
    }

    if (selectedColaborador) {
      computedComments = computedComments.filter((e) =>
        e.idVendedor.includes(selectedColaborador)
      );
    }

    if (activo) {
      computedComments = computedComments.filter(
        (e) => (e.is_active || "Si") === activo
      );
    }

    if (selectedTipo) {
      computedComments = computedComments.filter(pasaTipo);
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "importe" &&
      sorting.field != "total" &&
      sorting.field != "porcentaje" &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "importe" ||
        sorting.field == "total" ||
        sorting.field == "porcentaje" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "importe" ||
        sorting.field == "total" ||
        sorting.field == "porcentaje" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedColaborador,
    activo,
    selectedTipo,
    selectedFechaInicio,
    selectedFechaFin,
  ]);

 
function  pagarComision(id, idVendedor, importe){
  setIdPagar(id)
  setIdVendedorPagar(idVendedor)
  setImportePagar(importe)
  togglePagar()
}

function pagarComisionBanco(){
  Swal.fire({
    title: "Estas seguro?",
    text: "Se registrará el pago",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, Enviar!",
  }).then((result) => {
    if (result.isConfirmed) {
      axios
      .patch(
        `${URL_COMISIONES}Pagar/${idPagar}`,
        {
          pagada: "Si",
          colaboradores:idVendedorPagar,
          importe:importePagar
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem(
              "app_token"
            )}`,
          },
        }
      )
      .then(()=>{

        axios
        .post(
        `${URL_MOVIMIENTOS_BANCOS}`,
        {
            fecha:endDate,
            importe: -importePagar,
            tipo:"Egreso",
            bancos: selectedBanco,
            comisiones:idPagar,
            moneda,
            tipoCambio:1
        },
        {
            headers: {
            Authorization: `Bearer: ${localStorage.getItem(
                "app_token"
            )}`,
            },
        }
        )

        axios.post(
          URL_LOGS,
          {
            tipo: "Pagar Comision",
            detalle: `Comision: ${idPagar}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem(
                "app_token"
              )}`,
            },
          }
        );
        // Se espera el correo antes de recargar, si no el reload lo corta
        return enviaReciboVendedor(idPagar, idVendedorPagar).then(async (avisoMail) => {
          await Swal.fire("Good job!", `Pago registrado. ${avisoMail}`, "success");
          window.location.reload();
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log(error);
      });
    }
  });
}
 

function  cancelar(id){
  Swal.fire({
    title: "Estas seguro?",
    text: "Se va a cancelar",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, Cancelar!",
  }).then((result) => {
    if (result.isConfirmed) {
      axios
      .get(
        `${URL_COMISIONES}Cancel/${id}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem(
              "app_token"
            )}`,
          },
        }
      )
      .then(()=>{
        axios.post(
          URL_LOGS,
          {
            tipo: "Cancelar Comision",
            detalle: `Comision: ${id}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem(
                "app_token"
              )}`,
            },
          }
        );
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log(error);
      });
    }
  });
}
 
function editar(idEdit, vendedor, importe, porcentaje, total){
  setIdEdit(idEdit)
  setVendedor(vendedor)
  setImporte(importe)
  setPorcentaje(porcentaje)
  setTotal(total)
  setImporteNuevo(importe)
  toggle()
}

  function calculaComision(e) {
    setPorcentaje(e);

    let pRes = (total * e) / 100;
    setImporteNuevo(pRes);
  }

  function  editComision(){
    Swal.fire({
      title: "Estas seguro?",
      text: "Se actualizara la comision",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Enviar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
        .patch(
          `${URL_COMISIONES}EditImporte/${idEdit}`,
          {
            porcentaje,
            colaboradores:vendedor,
            importe:importeNuevo,
            diferenciaImporte: importe - importeNuevo
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem(
                "app_token"
              )}`,
            },
          }
        )
        .then(()=>{
          axios.post(
            URL_LOGS,
            {
              tipo: "Pagar Comision",
              detalle: `Comision: ${idEdit}`,
              user: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem(
                  "app_token"
                )}`,
              },
            }
          );
          Swal.fire("Good job!", "Creado con exito", "success");
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
          console.log(error);
        });
      }
    });
  }

  function jalaBanco(e) {
    setSelectedBanco(e);
    bancos.map((a) => {
      if (a._id == e) {
        return setMoneda(a.moneda);
      }
    });
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.comisionesCreate ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
            <Button
                size="sm"
                href="/ComisionesCreate"
                className="btn btn-success"
                id="botonListado"
              >
                Pagar Comision
              </Button>
              <Button
                size="sm"
                onClick={abrirViaticoExtra}
                className="btn btn-warning"
                style={{ marginLeft: 6 }}
              >
                <i className="fas fa-money-bill-wave"></i> Pagar Viatico Extra
              </Button>
              <Button
                size="sm"
                href="/MenuAdmin"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="warning"
                  onClick={PDFTablaBancos}
                  title="Reporte por pagar con datos bancarios"
                >
                  Reporte Bancos <i className="fas fa-university"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Comisiones</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Reporte de Comisiones</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Vendedor</Label>
            <Input
                bsSize="sm"
                type="select"
                value={selectedColaborador}
                onChange={(e) => {
                  setSelectedColaborador(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona un Vendedor</option>
                {colaboradores
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    return (
                      <option value={a._id}>
                        {a.nombre} {a.apellido}
                      </option>
                    );
                  })}
              </Input>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Activa</Label>
              <Input
                bsSize="sm"
                type="select"
                value={activo}
                onChange={(e) => {
                  setActivo(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="Si">Activas</option>
                <option value="">Todas</option>
                <option value="No">Canceladas</option>
              </Input>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Tipo</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedTipo}
                onChange={(e) => {
                  setSelectedTipo(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todos</option>
                <option value="Comisión">Solo comisión</option>
                <option value="Viático">Solo viático</option>
                <option value="Comisión y viático">Comisión y viático</option>
                <option value="conViatico">Todo lo que lleva viático</option>
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />

            <tbody>
              {commentsData.map((a) => {
                  return (
                    <tr  style={
                      a.is_active =="No"
                        ? { backgroundColor: "#ed8c8c" }:null
                    }>
                      <td>{a.numero}</td>
                      <td>{fDMA(a.fecha)}</td>
                      <td>{a.vendedor}</td>
                      <td>
                        {a.tipo}
                        {Number(a.viaticos) > 0 && a.tipo !== "Viático" ? (
                          <div style={{ fontSize: 11, color: "#666" }}>viáticos {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.viaticos)}</div>
                        ) : null}
                      </td>
                      <td>{ a.is_active =="Si"?(
                      new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total)
                      ):("CANCELADA")}</td>
                      <td>{a.porcentaje } %</td>
                      <td>{ a.is_active =="Si"?(
                      new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.importe)
                      ):("CANCELADA")}</td>
                      <td>{a.aplicada}</td>
                      <td>
                        {/* PDF con el detalle de comisiones y viáticos pagados */}
                        {a.is_active == "Si" ? (
                          <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            title="PDF detalle de la comisión"
                            onClick={() => PDFOC(a)}
                          >
                            <i class="far fa-file-pdf"></i>
                          </Button>
                        ) : undefined}
                        {a.is_active == "Si"?(
                        a.pagada =="No"?(
                          <>
                      <Button size="sm"
                      className="btn"
                      color="primary"
                      onClick={(e) =>
                       pagarComision(
                          a._id,
                          a.idVendedor,
                          a.importe
                        )
                      }
                    >
                    <i class="far fa-check-circle"></i>
                      </Button>
                      <Button size="sm"
                      className="btn"
                      color="info"
                      onClick={(e) =>
                       editar(
                          a._id,
                          a.idVendedor,
                          a.importe,
                          a.porcentaje,
                          a.total
                        )
                      }
                    >
                    <i class="far fa-edit"></i>
                      </Button>

                        <Button size="sm"
                        className="btn"
                        color="danger"
                        onClick={(e) =>
                         cancelar(
                            a._id,
                          )
                        }
                        >
                        <i class="far fa-times-circle"></i>
                        </Button>
                        </>
                        ):undefined

                        ):undefined}

                            {/* <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFOC(
                                  a.fecha,
                                  a.clientes,
                                  a.numero,
                                  a._id,
                                  a.impuestos,
                                  a.area,
                                  a.subTotal,
                                  a.iva,
                                  a.total_general,
                                  a.total_cantidad
                                )
                              }
                            >
                              <i class="far fa-file-pdf"></i>
                            </Button> */}
                         
                    </td>
                    </tr>
                  );
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Editar</ModalHeader>
        <ModalBody>
        <Table>
                       

                        <tr>
                          <th>Total</th>
                          <td align="right">
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              maximumFractionDigits: 2,
                            }).format(total)}
                          </td>
                        </tr>

                        <tr>
                          <th>Porcentaje</th>
                          <td align="right">
                            <Row>
                              <Col md={7}></Col>
                              <Col md={5}>
                                <Input
                                  bsSize="sm"
                                  type="number"
                                  min="0"
                                  step="any"
                                  value={porcentaje}
                                  onChange={(e) => {
                                    calculaComision(e.target.value);
                                  }}
                                />
                              </Col>
                            </Row>
                          </td>
                        </tr>

                        <tr>
                          <th>Comision a Pagar</th>
                          <td style={{ "font-weight": "bold" }} align="right">
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              maximumFractionDigits: 2,
                            }).format(importeNuevo)}
                          </td>
                        </tr>
                      </Table>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editComision}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalPagar} toggle={togglePagar}>
        <ModalHeader toggle={togglePagar}>Pagar Comision</ModalHeader>
        <ModalBody>

        <Col md={6}>
                  <Label className="mr-sm-2">Banco</Label>
                  <Input
                    type="select"
                    value={selectedBanco}
                    onChange={(e) => {
                      jalaBanco(e.target.value);
                    }}
                  >
                    <option value="">Selecciona un Banco</option>
                    {bancos
                      .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.banco} {a.cuenta}
                          </option>
                        );
                      })}
                  </Input>
                </Col>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={pagarComisionBanco}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="md" isOpen={modalViaticoExtra} toggle={toggleViaticoExtra}>
        <ModalHeader toggle={toggleViaticoExtra}>
          <h4>Pagar Viatico Extra</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={6}>
              <Label>Fecha</Label>
              <Input
                type="date"
                value={vxFecha}
                onChange={(e) => setVxFecha(e.target.value)}
              />
            </Col>
            <Col md={6}>
              <Label>Colaborador</Label>
              <Input
                type="select"
                value={vxColaborador}
                onChange={(e) => setVxColaborador(e.target.value)}
              >
                <option value="">Selecciona</option>
                {colaboradores
                  .filter((c) => c.is_active === "Si" || !c.is_active)
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((c) => (
                    <option key={c._id} value={c._id}>
                      {c.nombre} {c.apellido}
                    </option>
                  ))}
              </Input>
            </Col>
          </Row>
          <Row style={{ marginTop: 8 }}>
            <Col md={6}>
              <Label>Monto</Label>
              <Input
                type="number"
                min="0"
                step="any"
                value={vxMonto}
                onChange={(e) => setVxMonto(e.target.value)}
              />
            </Col>
            <Col md={6}>
              <Label>Concepto</Label>
              <Input
                type="text"
                value={vxConcepto}
                onChange={(e) => setVxConcepto(e.target.value)}
                placeholder="Ej: Viatico extra por viaje"
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={saveViaticoExtra}>
            Guardar
          </Button>
          <Button color="secondary" onClick={toggleViaticoExtra}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

        </div>
      ) : undefined}
      <br />
      {loader}
    </>
  );
}

export default ListadoComisiones;
